module.exports = __webpack_public_path__ + "static/media/sharedgoals.3f3644b9.png";